module.exports = __webpack_public_path__ + "img/map.6c3765ae.png";